<script>
  import MenuItem from "./MenuItem.svelte";
  import {SupportMenu} from "@util/constant"
</script>


<MenuItem Menu={SupportMenu} />
